import { useState } from 'react';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { Button } from '@/components/ui/button';
import { X, Smartphone } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export function InstallPromptBanner() {
  const { isInstallable, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);
  const { translate: t } = useTranslation();

  if (!isInstallable || dismissed) return null;

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-3">
      <div className="flex items-start gap-3 max-w-screen-lg mx-auto">
        <div className="shrink-0 mt-0.5">
          <Smartphone className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">{t("install_banner_title")}</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {t("install_banner_desc")}
          </p>
          <div className="flex items-center gap-2 mt-2">
            <Button size="sm" onClick={promptInstall} className="h-7 text-xs px-3">
              {t("install_banner_install")}
            </Button>
            <Button size="sm" variant="ghost" onClick={() => setDismissed(true)} className="h-7 text-xs px-3 text-muted-foreground">
              {t("install_banner_not_now")}
            </Button>
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="shrink-0 text-muted-foreground hover:text-foreground transition-colors"
          aria-label={t("common_dismiss")}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
